/**
 * GOALS PAGE - FLO SIGNATURE DESIGN SYSTEM v2
 * Clean. Controlled. Consistent. Dark tool mode.
 */

import React, { useState, useCallback } from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Screen, Section, Button } from '../design/primitives';
import GoalList from '../components/GoalList';
import GoalForm from '../components/forms/GoalForm';

const GoalsPage: React.FC = () => {
  const [isGoalFormOpen, setIsGoalFormOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleGoalCreated = useCallback(() => {
    setRefreshKey(prevKey => prevKey + 1);
  }, []);

  return (
    <Screen>
      <Section
        title="Goals"
        action={
          <Button
            variant="primary"
            onClick={() => setIsGoalFormOpen(true)}
            icon={<PlusIcon style={{ width: '16px', height: '16px' }} />}
          >
            New Goal
          </Button>
        }
      >
        <GoalList key={refreshKey} />
      </Section>

      <GoalForm
        isOpen={isGoalFormOpen}
        onClose={() => setIsGoalFormOpen(false)}
        onGoalCreated={handleGoalCreated}
      />
    </Screen>
  );
};

export default GoalsPage;
